import React from 'react'
import { useWindowSize } from 'msp-integrations'
import { BaseAccordion, AccordionItem, Headline } from '../../../index'
import {
  LeftCol,
  productSpecsAccordionStyles,
  RightCol
} from './ProductSpecs.partials'
import { ProductSpecsProps } from './ProductSpecs.types'
import {
  getLinksTranslations,
  getTableTranslations
} from './ProductSpecs.utils'

const ProductSpecs = ({
  product,
  leftHeadline,
  leftImage = { url: '', name: '', showShadow: false },
  leftContent = '',
  rightHeadline,
  rightImage = { url: '', name: '', showShadow: false },
  rightContent = '',
  links
}: ProductSpecsProps) => {
  const { width, breakpoints } = useWindowSize()

  const isDesktop = width && width > breakpoints.sm
  const productSpecTableFields = getTableTranslations({ ...product })

  const leftColumn = (
    <LeftCol
      {...(isDesktop && { headline: leftHeadline })}
      content={leftContent}
      image={leftImage}
      productSpecFields={productSpecTableFields}
      showBorder={!!isDesktop}
    />
  )
  const rightColumn = (
    <RightCol
      {...(isDesktop && { headline: rightHeadline })}
      content={rightContent}
      image={rightImage}
      links={links}
    />
  )

  return isDesktop ? (
    <div className='productSpecsGrid'>
      {leftColumn}
      {rightColumn}
    </div>
  ) : (
    <BaseAccordion wrapperStyles='border-none productSpecsAccordion'>
      {(leftHeadline || leftContent) && (
        <AccordionItem
          buttonProps={{
            buttonText: <Headline tag='h4'>{leftHeadline}</Headline>,
            ...productSpecsAccordionStyles
          }}
          isOpen={true}
        >
          {leftColumn}
        </AccordionItem>
      )}
      {(rightHeadline || rightContent) && (
        <AccordionItem
          buttonProps={{
            buttonText: <Headline tag='h4'>{rightHeadline}</Headline>,
            ...productSpecsAccordionStyles
          }}
        >
          {rightColumn}
        </AccordionItem>
      )}
    </BaseAccordion>
  )
}

export default ProductSpecs
